import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import usersCircle from "../../../assets/images/users/users-circle-bg.png"
import "swiper/css";
import "swiper/css/pagination";

export interface Slide {
    id: number;
    title: string;
    description: string;
    image: string;
}

interface Props {
    slides: Slide[];
}

const AuthFeatureSlider: React.FC<Props> = ({ slides }) => {
    return (
        <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={24}
            slidesPerView={1}
            loop
            autoHeight
            autoplay={{
                delay: 4000,
                disableOnInteraction: false,
            }}
            pagination={{
                clickable: true,
            }}
            className="feature-slider auth-feature-slider"
        >
            <SwiperSlide>
                <div className="users-circle-bg">
                    <img src={usersCircle} alt="users-circle" className="z-n1" />
                    <div className="d-flex flex-column gap-3 position-absolute first-slide">
                        <h2 className="text-white">5,00,000+</h2>
                        <span>Creators</span>
                    </div>
                </div>
            </SwiperSlide>
            {slides.map((slide) => (
                <SwiperSlide key={slide.id}>
                    <div className="p-4 h-100">
                        <div className="h-100 border-0">
                            <div className="card-body">
                                <div className="row align-items-center" style={{gap: '2.75rem'}}>
                                    <div className="col-12 text-center">
                                        <img
                                            src={slide.image}
                                            alt={slide.title}
                                            className="img-fluid rounded feature-slider-image"
                                        />
                                    </div>
                                    <div className="col-12 mb-3 mb-lg-0">
                                        <h5 className="fw-bold text-center feature-slider-title">{slide.title}</h5>
                                        <p className="text-center mb-0 feature-slider-description pb-3">
                                            {slide.description}
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default AuthFeatureSlider;
